export enum EntityType {
    OUTLET = 'OUTLET',
    CONTACT = 'CONTACT'
}
